import { useAppSelector } from "../hooks/redux";
import { routes } from "./public/routes";
import { AppUpdateModal } from "../components/CustomComponents/AppUpdateModal";
import { APP_ENV } from "../constants/constant";
import {
  analyticsController,
  circadiaEngineProvider,
  localStorageProvider,
  timeProvider,
} from "../AppController";
import { AppRouter } from "./appRouter";
import { featureFlag } from "../constants/feature";
import { useNetworkStatus } from "../hooks/network";
import { useStatsTimeout } from "../hooks/useStatsTimeout";
// import VersionChecker from "../version";
import { ScreenLoaderWhite } from "../components/CustomComponents/ScreenLoaderWhite";
import { useEffect } from "react";
import { triggerIntercomOnLoginSuccess } from "../util/intercomTrigger";
import VitalsRedirectHandler from "../components/VitalsRedirectHandler";
import { useVitalsSubdomainRedirect } from "../hooks/useVitalsSubdomainRedirect";

window.chimeAudio = new Audio("/assets/audio/bed_exit_chime.wav");
window.chimeAudio.loop = true;

const Router = () => {
  // Handle vitals subdomain redirect - must be called first
  useVitalsSubdomainRedirect();

  useNetworkStatus({
    analyticsController,
    localStorageProvider,
    timeProvider,
  });
  useStatsTimeout();
  const { authState, isAuthorized, layoutState, user } = useAppSelector(
    (state) => {
      return {
        authState: state.auth.authState,
        isAuthorized: state.auth.isAuthorized,
        isPinAuthorized: state.auth.isPinAuthorized,
        layoutState: state.layout.layoutState,
        user: state.auth.user,
      };
    }
  );

  // Intercom auto-trigger after 20 seconds when user is logged in
  useEffect(() => {
    if (user && isAuthorized) {
      const timer = setTimeout(() => {
        const currentPath = window.location.hash || window.location.pathname;
        const shouldExclude = currentPath.includes("#/dashboard?patientIds");

        if (!shouldExclude) {
          triggerIntercomOnLoginSuccess();
        }
      }, 20000);

      return () => clearTimeout(timer);
    }
  }, [user, isAuthorized]);

  const getLayoutToRender = () => {
    const url = window.location.hash.slice(1).split("?")[0];

    if (
      !isAuthorized &&
      !Object.entries(routes)
        .map(([_key, value]) => value.path)
        // @ts-ignore
        .includes(url)
    ) {
      localStorageProvider.set("prevUrl", window.location.hash.slice(1));
    }

    if (layoutState === "loading" || authState === "loading") {
      return <ScreenLoaderWhite />;
    }

    return <AppRouter />;
  };

  const showUpdateModal =
    APP_ENV === "prod" &&
    circadiaEngineProvider.plat === "ios" &&
    circadiaEngineProvider.intfv < 4 &&
    featureFlag.appUpdateModal; // feature flag

  return (
    <>
      {/* removing version checker for this release */}
      {/* {window.location.hostname !== "localhost" && <VersionChecker />} */}
      {/* <AppPerformanceSurvey /> */}
      <AppUpdateModal visible={showUpdateModal} />
      <VitalsRedirectHandler />
      {getLayoutToRender()}
    </>
  );
};

export default Router;
